/* eslint-disable indent */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

import Master from '../Master';
import IziToast from '../IziToast';
import ButtonTile from '../ButtonTile';
import TenantsTable from './TenantsTable';
import InfoPanel from '../Panels/InfoPanel';
import Button from '../Buttons';
import SearchInput from '../SearchInput';
import PropertyAccess from '../../data/AccessRights';

const Tenants = ({ user, location: { property } }) => {
  // token
  const userToken = user ? user.token : {};
  const requestConfig = {
    headers: {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json',
    },
  };

  // state
  const history = useHistory();
  const [properties, setProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [filteredProperties, setFilteredProperties] = useState([]);

  useEffect(() => {
    let url = `/byuser?status=active&user_id=${user.id}`;
    if (user && user.type === 'admin') {
      // eslint-disable-next-line quotes
      url = `?take=1000&where={"status":"active"}`;
    }
    axios
      .get(`${process.env.REACT_APP_API_URL}properties${url}`, requestConfig)
      .then((res) => {
        if (res.data) {
          if (res.data.response) {
            const { response } = res.data;
            // sort by name asc
            response.sort((a, b) => {
              return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
            });

            setProperties(response);
            setFilteredProperties(response);
          }
        }
      })
      .catch(() => {
        IziToast('Could not load your properties');
      });
  }, []);

  useEffect(() => {
    if (property && property.id) {
      setSelectedProperty(property);
      //  const scrollTile = window.document.querySelector('.property-tile');
      //       window.console.dir(scrollTile);
      // if (scrollTile) {
      //   scrollTile.scrollIntoView({
      //     behavior: 'smooth',
      //     block: 'end',
      //     inline: 'nearest',
      //   });
      // }
    }
  }, [property]);

  const searchProperties = (event) => {
    const { value } = event.target;
    setSearchValue(value);
    const data = value
      ? properties.filter((item) => {
          return item.name
            .toLocaleLowerCase()
            .includes(value.toLocaleLowerCase());
        })
      : properties;
    if (data.length) {
      setFilteredProperties(data);
    }
  };

  function newTenant() {
    if (!selectedProperty) {
      IziToast('Select property name first');
    } else {
      const obj = {
        id: selectedProperty.id,
        name: selectedProperty.name,
      };
      if (typeof Storage !== 'undefined') {
        window.localStorage.setItem('property', JSON.stringify(obj));
        window.localStorage.setItem('source', 'tenantslist');
      }
      history.push({
        pathname: '/newtenant',
        property: selectedProperty,
        source: 'tenants',
      });
    }
  }

  return (
    <Master
      redirectLink="tenants"
      title="Property Management"
      source="Tenants List"
    >
      <div className="row">
        <div className="col-md-3">
          <SearchInput
            onChange={searchProperties}
            value={searchValue}
            placeholder="Search property..."
            columnWidth={12}
          />
          <div
            style={{ maxHeight: '500px', overflowY: 'scroll', padding: '5px' }}
          >
            {filteredProperties.map((item) => {
              return (
                <ButtonTile
                  controlId={`tile_${item.id}`}
                  key={item.id}
                  content={item.name}
                  onClick={() => {
                    setSelectedProperty(item);
                  }}
                  isActive={selectedProperty.id === item.id}
                />
              );
            })}
          </div>
        </div>
        <div className="col-md-9">
          {user && PropertyAccess.includes(user.type) && (
            <div className="">
              <div style={{ textAlign: 'right' }}>
                <Button
                  caption="Add New Tenant"
                  cssClass="btn-success"
                  onClick={newTenant}
                  type="button"
                  isBlack={false}
                />
              </div>
            </div>
          )}
          <div className="">
            {selectedProperty ? (
              <TenantsTable userToken={userToken} property={selectedProperty} />
            ) : (
              <InfoPanel message="Select property to view tenants" />
            )}
          </div>
        </div>
      </div>
    </Master>
  );
};

Tenants.propTypes = {};

const mapStateToProps = (state) => {
  return state;
};

Tenants.propTypes = {
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

Tenants.defaultProps = {
  user: {},
  location: {},
};

export default connect(mapStateToProps)(Tenants);
